import FacebookIcon from '~/assets/icons/Facebook';

import Tracked from '../Tracked';

const ShareToFacebook = ({ url }: { url: string }) => {
  const href = `https://www.facebook.com/sharer/sharer.php?u=${url}`;

  function onClick() {
    window.open(
      href,
      'popUpWindow',
      'height=500,width=400,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes'
    );
  }

  return (
    <Tracked.Button
      variant="none"
      onClick={onClick}
      className="cursor-pointer"
      name="SHARE_TO_FACEBOOK"
      pagePosition="Body"
    >
      <FacebookIcon height="24" width="24" fill="black" />
    </Tracked.Button>
  );
};

export default ShareToFacebook;
